import { UtilityAccount } from '~/services/fetch-existing-utility-accounts';

export const TEST_UTILITY_ACCOUNTS: UtilityAccount[] = [
  {
    id: 1,
    accountNumber: '123456789',
    displayServiceAddress: '123 Main St, Nowhere, NW 99999',
    hasVnmProduct: false,
    hasInValidScraperDetails: false,
    utility: {
      id: 1,
      displayName: 'National Grid MA',
    },
  },
  {
    id: 2,
    accountNumber: null,
    displayServiceAddress: '46 Fake Drive, Fakeston, FK 98989',
    hasVnmProduct: true,
    hasInValidScraperDetails: false,
    utility: {
      id: 2,
      displayName: 'Commonwealth Edison',
    },
  },
  {
    id: 3,
    accountNumber: '987654321',
    displayServiceAddress: '',
    hasVnmProduct: true,
    hasInValidScraperDetails: false,
    utility: {
      id: 2,
      displayName: 'CommonWealth Edison',
    },
  },
  {
    id: 4,
    accountNumber: null,
    displayServiceAddress: '',
    hasVnmProduct: true,
    hasInValidScraperDetails: false,
    utility: {
      id: 1,
      displayName: 'National Grid',
    },
  },
  {
    id: 5,
    accountNumber: '1212121212',
    displayServiceAddress: '123 Main St, Nowhere, NW 99999',
    hasVnmProduct: true,
    hasInValidScraperDetails: false,
    utility: {
      id: 3,
      displayName: 'Dominion Energy VA',
    },
  },
  {
    id: 6,
    accountNumber: '2323232323',
    displayServiceAddress: '123 Main St, Nowhere, NW 99999',
    hasVnmProduct: true,
    hasInValidScraperDetails: false,
    utility: {
      id: 1,
      displayName: 'National Grid',
    },
  },
];
